import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IGetActivityItems,
  IActivityItemParams,
  ISemesterActivityReq,
  IGetSemesterTimetables,
  IGetActivityItemsHW,
  IActivityItemsHWParams,
} from '../models/semesterProduct.model';
import QueryString from 'qs';

const uri = '/mgmt/semester-product';
const evaluationUri = '/mgmt/evaluation/semester-seq';

export const getActivityItems = (
  params: IActivityItemParams,
): AxiosPromise<IGetActivityItems> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getSemesterTimetables = (
  semesterCourseCode: number,
): AxiosPromise<IGetSemesterTimetables> => {
  return axios.get(`${uri}/${semesterCourseCode}/timetables`);
};

export const createSemesterActivity = (
  semesterCourseCode: number,
  timetableSeq: number,
  data: ISemesterActivityReq,
): AxiosPromise => {
  return axios.post(
    `${evaluationUri}/${semesterCourseCode}/${timetableSeq}`,
    data,
  );
};

export const updateSemesterActivity = (
  semesterCourseCode: number,
  semesterSeqEvaluationCode: number,
  data: ISemesterActivityReq,
): AxiosPromise => {
  return axios.put(
    `${evaluationUri}/${semesterCourseCode}/${semesterSeqEvaluationCode}`,
    data,
  );
};

export const deleteSemesterActivity = (
  semesterSeqEvaluationCode: number,
): AxiosPromise => {
  return axios.delete(`${evaluationUri}/${semesterSeqEvaluationCode}`);
};

export const getActivityItemsHW = (
  params: IActivityItemsHWParams,
): AxiosPromise<IGetActivityItemsHW> => axios.get(`${uri}/hw`, { params });
